import { EmployeeModel } from 'src/app/model/employee.model';
import { AppState } from '../../../../store/app.states';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { LoadMoreAction, RequestAction, ResetAction } from './actions';
import { ComponentBase } from '../../../../views/component-base';
import { EmployerPortalSharedState } from '../../store/shared.states';
import { Router } from '@angular/router';
import { commomState_SystemConfig_Config } from 'src/app/store/common/common.selectors';
import { employeeListView_Filter, employeeListView_isLoading, employeeListView_List } from './selectors';
import { debounceTime, distinctUntilChanged, throttleTime } from 'rxjs/operators';

@Component({
  selector: 'app-employee-list-view',
  templateUrl: './employee-list-view.component.html',
  styleUrls: ['./employee-list-view.component.scss']
})
export class EmployeeListViewComponent extends ComponentBase implements OnInit, OnDestroy {

  list$ = this.store.pipe(select(employeeListView_List));
  tenantConfig$ = this.appstore.pipe(select(commomState_SystemConfig_Config));
  filter$ = this.appstore.pipe(select(employeeListView_Filter));
  isLoading$ = this.appstore.pipe(select(employeeListView_isLoading));

  constructor(
    public store: Store<EmployerPortalSharedState>,
    public appstore: Store<AppState>,
    private router: Router) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
    this.sub = this.filter$
      .pipe(
        debounceTime(500),
        distinctUntilChanged((prev, curr) => prev.value.q === curr.value.q && prev.value.currentPage === curr.value.currentPage))
      .subscribe(filter => {
        if (filter.value.currentPage != -1)
          this.store.dispatch(RequestAction({ search: filter.value.q, page: filter.value.currentPage }));
      })
    this.screenWidthChange(this.appstore, x => { });
  }

  endOfPageEvent() {
    this.store.dispatch(LoadMoreAction())
  }



  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  personalDetails() {
    this.router.navigate(['personal-details']);
  }

  changePassword() {
    this.router.navigate(['change-password']);
  }

  // onSelectEmployeeClick(model: EmployeeModel) {
  //   this.router.navigate(['change-password']);
  // }
}
